export const ACCESO_ATIENDO_URL = "https://acceso.atiendo.com/";

export const esProduccion = import.meta.env.VITE_ENV_NOMBRE === "Produccion";

export const redirigirAccesoAtiendo = () => {
  if (!esProduccion) return;
  window.location.href = ACCESO_ATIENDO_URL;
};
